import $ from 'jquery';

export const scrollUpListener = (selector,menuColor,offset=10) => {
    try{
       
        let scroll_pos = 0;
        console.log('scroll_pos',scroll_pos)
        $(document).scroll(function(){ 
            scroll_pos = $(this).scrollTop();
            // console.log("scroll position",scroll_pos);
            if(scroll_pos > offset) {
                $(selector).css('background',menuColor.assetBackgroundSelectorColor);
                //   $(selector).css('position',"fixed");
            } else {
                $(selector).css('background', "transparent");
                //   $(selector).css('position',"relative");
            }
        });
        
    }catch(e){
        console.log("Error in scroll up listener func",e);
    }
}


export const scrollUpListenerToShowHideElement = (selector, offset, notificationPage, callBack) => {
    let scroll_pos = 0;
    let threshold
        $(document).scroll(function(){
        scroll_pos = $(this).scrollTop();
        console.log('scroll_pos', scroll_pos)
        if(window.screen.width >= 1024){
            threshold = 353
        } else if(window.screen.width >= 500 && window.screen.width < 1024 ){
            threshold = 290
        } else {
            threshold = 219
        }
        if( scroll_pos >= threshold && !notificationPage){
            callBack(true);
        } else {
            callBack(false);
        }
    })
}

export const scrollUpListenerForConditionalRendering = (callback, offset) => {
    let scroll_pos = 0;
        $(document).scroll(function(){
            scroll_pos = $(this).scrollTop();
            if(scroll_pos > offset){
                callback(true)
            } else {
                callback(false)
            }
        })
}

export const scrollUpEffect = (selector,menuColor,offset=10) => {
    try{
        const container = document.getElementById(selector);
        let scroll_pos = container.scrollTop;
        // console.log("container.scrollTop",container.scrollTop)
        if(scroll_pos > offset) {
            $("div.customOverlay").css('background',menuColor.assetBackgroundSelectorColor);
        //   $(selector).css('position',"fixed");
        } else {
            $("div.customOverlay").css('background', "transparent");
        //   $(selector).css('position',"relative");
        }
    }catch(e){
        console.log("Error in scroll up effect func",e);
    }
}

let callBackFuncCalled = false;

export const scrollDownEffect = (divId,headerId,menuColor,defHeader=13,callBackFunc) => {

    let startY,headerHeight,touchY;
    const imageHeight = 200;

    const onScrollHandler = () => {
       
        const scrollTop = document.scrollingElement.scrollTop;

        if(!divId || divId == null){
            return
        }

        if (document.getElementById(divId)) {
            if(navigator.onLine){
                if ($(document).scrollTop() > 5) {
                    document.getElementById(divId).style.background = menuColor.backgroundColor;
                    
                } else {
                    document.getElementById(divId).style.background = "transparent";
                }
            }
            
        }        
    }

    const touchStartHandler = (event) => {
        // console.log("Start Y",event.touches[0].pageY);
        startY = event.touches[0].pageY;
        if(!headerHeight && $(`#${headerId}`)[0]){
            headerHeight = $(`#${headerId}`)[0].clientHeight / 16;
        }
    }

    const touchMoveHandler = (event) => {

        if(!headerHeight){
            return;
        }

       const y = event.touches[0].pageY;
       const scrollTop = document.scrollingElement.scrollTop;
       const imageStretch = $(`#${headerId}`)[0];
        
        if(!imageStretch){
            return;
        }

      touchY = y;

       if (scrollTop === 0 && y > startY && y > headerHeight) {
            
            // let expDecay = 15*Math.exp(-0.006 * (y - this.startY));
            // let expDecay = 10 * Math.sin((y - this.startY + this.start/4)/y * Math.PI)
            // let height = Math.min(this.headerHeight +  expDecay, y/16);

            // console.log(`exp decay: ${expDecay} y/16: ${y/16}, height: ${height}`);
            let limit = headerHeight + 20
            let diff = (y - startY)/16
            let coeff = (limit-y/16)/limit
            let height = limit > y/16 ? headerHeight + coeff*diff : limit;

            // console.log(`limit: ${limit} diff: ${diff}, coeff: ${coeff} height: ${height}`);

            if(height < (limit)){
                imageStretch.style.height = height + "rem";
            }

            if((height > (defHeader + 5)) && !callBackFuncCalled){
                callBackFuncCalled = true;
                if(callBackFunc){
                    callBackFunc(height)
                }
            }
            
        }
        else if (scrollTop > 0 && scrollTop <= imageHeight) {
            // imageStretch.style.transform = `translateY(-${scrollTop / 2}px)`;
            
        }
        else {
            // imageStretch.style.transform = "translateY(0px)";
            imageStretch.style.height = defHeader + "rem";
            
        }
    }

    const touchEndHandler = (event) => {
        callBackFuncCalled = false;
        const scrollTop = document.scrollingElement.scrollTop;
        const imageStretch = $(`#${headerId}`)[0];

        if(!imageStretch){
            return;
        }
       
        imageStretch.style.transitionDuration = "350ms";
        imageStretch.style.transitionProperty = "all"

        imageStretch.style.height = defHeader + "rem";
        // imageStretch.style.transform = "translateY(0px)";
    
            
       
    }

    window.addEventListener('scroll',onScrollHandler);
    window.addEventListener('touchmove',touchMoveHandler);
    window.addEventListener('touchstart',touchStartHandler);
    window.addEventListener('touchend',touchEndHandler);
   
}

export const removeScrollDown = () => {
    window.removeEventListener("scroll",() => {});
    window.removeEventListener('touchmove',() => {});
    window.removeEventListener('touchstart',() => {});
    window.removeEventListener('touchend',() => {});
    document.removeEventListener("scroll",() => {});
    $(document).off("scroll",() => {}) 
}